import { Listado_Documentos } from './../../../models/listado_documentos.model';
import { Component, ViewChild, TemplateRef } from "@angular/core";
import { FormControl, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { MatDialog } from '@angular/material';
declare var jQuery: any;
declare var $: any;

@Component({
  selector: 'app-listado-documentos',
  templateUrl: './listado-documentos.component.html',
  styleUrls: ['./listado-documentos.component.css'],
  providers: [FormService]
})
export class ListadoDocumentosComponent {
  @ViewChild('openModal') openModal: TemplateRef<any>;
  @ViewChild('openModalNODATA') openModalNODATA: TemplateRef<any>;

  public rows = [];
  public actualRow;
  public Listado_Documentos: Listado_Documentos;
  public formulario;
  public temp_clasif;
  public matcher = new FormService();

  constructor(private dialog: MatDialog) {

    this.formulario = new FormGroup({
      rae: new FormControl(''),
      contenido: new FormControl(''),
      nota: new FormControl(''),

    })
    if (!JSON.parse(localStorage.getItem("Listado_Documentos"))) {
      localStorage.setItem("Listado_Documentos", JSON.stringify(this.rows));
    } else {
      this.rows = JSON.parse(localStorage.getItem("Listado_Documentos"));

    }
    this.Listado_Documentos = {
      rae: "",
      contenido: "",
      nota: "",
    };
    this.temp_clasif = {
      rae: "",
      contenido: "",
      nota: "",
    };
  }

  add_clasificacion() {


    this.actualRow = localStorage.getItem("Listado_Documentos");
    this.rows = JSON.parse(this.actualRow);

    if (!this.formulario.value.rae || !this.formulario.value.contenido ) {
      console.log("no se ingresaron datos");
      this.dialog.open(this.openModalNODATA);

    } else {
      this.rows = this.rows.concat({
        rae: this.formulario.value.rae,
        contenido: this.formulario.value.contenido,
        nota: this.formulario.value.nota,

      })
      localStorage.setItem("Listado_Documentos", JSON.stringify(this.rows));
      this.formulario.reset();
    }




  }

  get_clasificacion(id) {
    for (let x = 0; x < this.rows.length; x++) {
      if (id == x) {
        this.temp_clasif.id = id;
        this.temp_clasif.rae = this.rows[x].rae;
        this.temp_clasif.contenido = this.rows[x].contenido;
        this.temp_clasif.nota = this.rows[x].nota;


        this.dialog.open(this.openModal);
      }
    }
  }

  cleanData() {
    this.temp_clasif = {
      rae: "",
      contenido: "",
      nota: "",
    };
  }

  saveclasificacion() {
    var id = this.temp_clasif.id;
    for (let x = 0; x < this.rows.length; x++) {
      if (id == x) {
        this.rows.splice(x, 1);
        localStorage.setItem("Listado_Documentos", JSON.stringify(this.rows));

        $("#clasif_modal").modal("hide");
        this.actualRow = localStorage.getItem("Listado_Documentos");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
          rae: this.temp_clasif.rae,
          contenido: this.temp_clasif.contenido,
          nota: this.temp_clasif.nota,

        })
        localStorage.setItem("Listado_Documentos", JSON.stringify(this.rows));
        this.temp_clasif = {
          rae: "",
          contenido: "",
          nota: "",
        };
        this.dialog.closeAll();
      }
    }
  }

  delete_clasificacion(id) {
    for (let x = 0; x < this.rows.length; x++) {
      if (id == x) {
        this.rows.splice(x, 1);
        localStorage.setItem("Listado_Documentos", JSON.stringify(this.rows));
      }
    }
    this.actualRow = localStorage.getItem("Listado_Documentos");
    this.rows = JSON.parse(this.actualRow);
  }
}
